<script>
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'

export default {
  name: 'FundraiserPublishButton',
  components: { TwButton },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: null,
    }
  },
  emits: ['fundraiser-published', 'fundraiser-unpublished'],
  data() {
    return {
      Loading: false,
      ValidationErrorMessage: null
    }
  },
  methods: {
    async publishFundraiser() {
      try {
        if(confirm('Are you sure you want to publish this fundraiser?')) {
          this.Loading = true
          const fundraiser = await useFundraiserStore().fundraiserPublish(this.fundraiser.id)
          this.Loading = false
          this.$emit('fundraiser-published', fundraiser)
        }
      } catch (e) {
        console.error(e)
        this.Loading = false
      }
    },
    async unpublishFundraiser() {
      try {
        if(confirm('Are you sure you want to unpublish this fundraiser?')) {
          this.Loading = true
          await useFundraiserStore().fundraiserUnPublish(this.fundraiser.id)
          this.Loading = false
          this.$emit('fundraiser-unpublished', fundraiser)
        }
      } catch (e) {
        console.error(e)
        this.Loading = false
      }
    }
  }
}
</script>

<template>
  <tw-button v-if="fundraiser.published" :size="size" variant="secondary" icon="file-excel" @click="unpublishFundraiser">
    Unpublish {{ $t('fundraiser') }}
  </tw-button>
  <tw-button v-else :size="size" variant="amber" icon="file-arrow-up" @click="publishFundraiser">
    Publish {{ $t('fundraiser') }}
  </tw-button>
</template>

<style scoped>

</style>
